// src/components/LaborInfo.jsx
import React from "react";
import { Form, Select, DatePicker, Row, Col, Typography, Input, Alert } from "antd";
import { WarningOutlined } from "@ant-design/icons";
import PropTypes from "prop-types";
import dayjs from "../../../../utils/dayjs"; // Ajusta la ruta según tu estructura

const { Option } = Select;
const { Title } = Typography;
const { TextArea } = Input;

const LaborInfo = ({
  driver,
  handleInputChange,
  errors,
  isEdit = false,
  initialEstado = null,
  estadoObservacion = "",
  onEstadoObservacionChange = () => {},
}) => {
  // Verificar si el estado cambió (solo en modo edición)
  const estadoCambio = isEdit && initialEstado && driver.estado !== initialEstado;

  return (
  <>
    <Title
      level={4}
      style={{
        backgroundColor: "#0a2e5c",
        color: "white",
        padding: "8px 16px",
        borderRadius: "4px",
        marginTop: 24,
        marginBottom: 16,
      }}
    >
      Información Laboral
    </Title>
    <Row gutter={16}>
      <Col xs={24} sm={12}>
        <Form.Item
          label="Estado"
          required
          validateStatus={errors.estado ? "error" : ""}
          help={errors.estado}
        >
          <Select
            value={driver.estado}
            onChange={(value) =>
              handleInputChange({ target: { name: "estado", value } })
            }
            placeholder="Seleccione Estado"
          >
            <Option value="Activo">Activo</Option>
            <Option value="Inactivo">Inactivo</Option>
            <Option value="Suspendido">Suspendido</Option>
          </Select>
        </Form.Item>
      </Col>
      <Col xs={24} sm={12}>
        <Form.Item
          label="Fecha de Ingreso"
          required
          validateStatus={errors.fecha_ingreso ? "error" : ""}
          help={errors.fecha_ingreso}
        >
          <DatePicker
            name="fecha_ingreso"
            value={driver.fecha_ingreso ? dayjs(driver.fecha_ingreso) : null}
            onChange={(date, dateString) =>
              handleInputChange({
                target: { name: "fecha_ingreso", value: dateString },
              })
            }
            format="YYYY-MM-DD"
            style={{ width: "100%" }}
          />
        </Form.Item>
      </Col>
      <Col xs={24} sm={12}>
        <Form.Item
          label="Fecha de Terminación de Contrato"
          required
          validateStatus={errors.fecha_fin_contrato ? "error" : ""}
          help={errors.fecha_fin_contrato}
        >
          <DatePicker
            name="fecha_fin_contrato"
            value={
              driver.fecha_fin_contrato
                ? dayjs(driver.fecha_fin_contrato)
                : null
            }
            onChange={(date, dateString) =>
              handleInputChange({
                target: { name: "fecha_fin_contrato", value: dateString },
              })
            }
            format="YYYY-MM-DD"
            style={{ width: "100%" }}
          />
        </Form.Item>
      </Col>

      {/* Campo de observación cuando cambia el estado */}
      {estadoCambio && (
        <Col xs={24}>
          <Alert
            message={`Cambio de estado: ${initialEstado} → ${driver.estado}`}
            description="Se requiere una observación para justificar el cambio de estado."
            type="warning"
            showIcon
            icon={<WarningOutlined />}
            style={{ marginBottom: 16 }}
          />
          <Form.Item
            label="Observación del cambio de estado"
            required
            validateStatus={errors.observacion_cambio_estado ? "error" : ""}
            help={errors.observacion_cambio_estado}
          >
            <TextArea
              rows={3}
              placeholder="Ingrese el motivo del cambio de estado (obligatorio)"
              value={estadoObservacion}
              onChange={(e) => onEstadoObservacionChange(e.target.value)}
              maxLength={500}
              showCount
            />
          </Form.Item>
        </Col>
      )}
    </Row>
  </>
  );
};

LaborInfo.propTypes = {
  driver: PropTypes.object.isRequired,
  handleInputChange: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
  isEdit: PropTypes.bool,
  initialEstado: PropTypes.string,
  estadoObservacion: PropTypes.string,
  onEstadoObservacionChange: PropTypes.func,
};

export default LaborInfo;
